import Tab from '../../../UI/TabbedContent/Tab/Tab';
import TabbedContent from '../../../UI/TabbedContent/TabbedContent';
import TabContent from '../../../UI/TabbedContent/TabContent/TabContent';
import TabTitle from '../../../UI/TabbedContent/TabTitle/TabTitle';
import Locale from '../../lang/locale';
import Translation from '../../lang/Translation';
import CheckoutOverlay from '../CheckoutOverlay/CheckoutOverlay';
import ImportTaxHelpContent from './ImportTaxHelpContent';

function ImportTaxHelpOverlay() {
  const isChineseLocale = Locale.get() && Locale.get().startsWith('zh');
  return (
    <CheckoutOverlay popup nopadding title="deliveryOptions.import.tax.help.title">
      <div className="ImportTaxHelpOverlay">
        {isChineseLocale ? <ImportTaxHelpContent /> : (
          <TabbedContent>
            <Tab>
              <TabTitle><Translation>checkout.chineseLanguage</Translation></TabTitle>
              <TabContent><ImportTaxHelpContent chineseLanguage /></TabContent>
            </Tab>
            <Tab>
              <TabTitle><Translation>checkout.thisLanguage</Translation></TabTitle>
              <TabContent><ImportTaxHelpContent /></TabContent>
            </Tab>
          </TabbedContent>
        )}
      </div>
    </CheckoutOverlay>
  );
}

export default ImportTaxHelpOverlay;
